import { spacer16 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { cssColorValue, cssSpacerValue, semanticColors } from "../../styles";
import { TypeList } from "../TypeList";
export var AccordionPanel = styled(TypeList).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "Panel__AccordionPanel",
  componentId: "sc-jkxemo-0"
})(["color:", ";background-color:", ";padding-block-end:", ";"], cssColorValue(semanticColors.textBase), cssColorValue(semanticColors.backgroundBase), cssSpacerValue(0, spacer16));